/** Form / hasta akıllı içgörü kartları — panel SSOT */

import { PANEL } from "./panelTokens";
import { panelTableCardSx } from "./panelCardSx";
import { panelFormSectionTitleSx } from "./panelFormSx";

export const formInsightSectionStackSx = {
  display: "grid",
  gap: 2.5,
};

export const formInsightModuleSx = {
  ...panelTableCardSx,
  overflow: "hidden",
  borderLeft: `3px solid ${PANEL.accent.main}`,
};

export const formInsightModuleHeaderSx = {
  display: "flex",
  alignItems: "flex-start",
  gap: 1.5,
  px: { xs: 2, md: 2.5 },
  pt: { xs: 2, md: 2.25 },
  pb: 1.5,
  borderBottom: `1px solid ${PANEL.border}`,
};

export const formInsightModuleIconSx = {
  width: 40,
  height: 40,
  borderRadius: "12px",
  display: "grid",
  placeItems: "center",
  flexShrink: 0,
  bgcolor: PANEL.accent.soft12,
  color: PANEL.accent.text,
  border: `1px solid ${PANEL.accent.softBorder22}`,
  "& .MuiSvgIcon-root": { fontSize: 20 },
};

export const formInsightModuleIndexSx = {
  fontSize: "0.65rem",
  fontWeight: 700,
  letterSpacing: "0.1em",
  color: PANEL.text.label,
  fontVariantNumeric: "tabular-nums",
};

export const formInsightModuleTitleSx = {
  ...panelFormSectionTitleSx,
  mb: 0,
  fontSize: "1rem",
  lineHeight: 1.3,
};

export const formInsightModuleSubtitleSx = {
  mt: 0.45,
  fontSize: "0.8125rem",
  color: PANEL.text.muted,
  lineHeight: 1.45,
  maxWidth: 560,
};

export const formInsightModuleBodySx = {
  px: { xs: 2, md: 2.5 },
  pb: { xs: 2, md: 2.35 },
};

export const formInsightMetricSx = {
  px: 1.25,
  py: 1.1,
  borderRadius: PANEL.radius.cardSm,
  bgcolor: PANEL.fill.muted,
  border: `1px solid ${PANEL.border}`,
  minHeight: 64,
};

export const formInsightMetricLabelSx = {
  fontSize: "0.64rem",
  fontWeight: 600,
  color: PANEL.text.muted,
  letterSpacing: "0.06em",
  textTransform: "none",
  mb: 0.55,
  display: "flex",
  alignItems: "center",
  gap: 0.5,
};

export const formInsightMetricValueSx = (accent) => ({
  fontWeight: 700,
  fontSize: "1.05rem",
  color: accent || PANEL.text.primary,
  lineHeight: 1.2,
  letterSpacing: "-0.02em",
  fontVariantNumeric: "tabular-nums",
});

export const formInsightCardShellSx = {
  borderRadius: PANEL.radius.cardMd,
  border: `1px solid ${PANEL.border}`,
  bgcolor: PANEL.surface,
  overflow: "hidden",
  minWidth: 0,
  height: "100%",
  display: "flex",
  flexDirection: "column",
  boxShadow: PANEL.shadow.card,
  transition: "box-shadow 0.2s ease, border-color 0.2s ease",
  "&:hover": {
    borderColor: PANEL.accent.softBorder22,
    boxShadow: PANEL.shadow.cardHover,
  },
};

export const formInsightCardHeaderSx = {
  px: 1.65,
  pt: 1.5,
  pb: 1.25,
  borderBottom: `1px solid ${PANEL.border}`,
};

export const formInsightCardTitleSx = {
  fontWeight: 700,
  fontSize: "0.95rem",
  color: PANEL.text.primary,
  letterSpacing: "-0.02em",
};

export const formInsightCardSummarySx = {
  fontSize: "0.78rem",
  color: PANEL.text.muted,
  lineHeight: 1.5,
};

export const formInsightCardBodySx = {
  p: 1.65,
  display: "grid",
  gap: 1.1,
  flex: 1,
  alignContent: "start",
};

export const formInsightKindChipSx = {
  height: 20,
  fontSize: "0.62rem",
  fontWeight: 650,
  letterSpacing: "0.02em",
  bgcolor: PANEL.accent.soft12,
  color: PANEL.accent.text,
  border: `1px solid ${PANEL.accent.softBorder}`,
  "& .MuiChip-label": { px: 0.85 },
};

export const formInsightOptionBoxSx = {
  p: 1.1,
  borderRadius: PANEL.radius.cardSm,
  bgcolor: PANEL.fill.muted,
  border: `1px solid ${PANEL.border}`,
};

export const formInsightHorizScrollSx = {
  display: "flex",
  flexWrap: "nowrap",
  alignItems: "stretch",
  gap: 1.75,
  overflowX: "auto",
  overflowY: "hidden",
  pb: 1,
  mx: { xs: -0.5, md: 0 },
  px: { xs: 0.5, md: 0 },
  scrollSnapType: "x mandatory",
  WebkitOverflowScrolling: "touch",
  "&::-webkit-scrollbar": { height: 6 },
  "&::-webkit-scrollbar-thumb": {
    bgcolor: PANEL.fill.hover,
    borderRadius: 8,
  },
  "&::-webkit-scrollbar-track": {
    bgcolor: PANEL.fill.subtle,
    borderRadius: 8,
  },
};

export const formInsightScrollCardShellSx = {
  flex: "0 0 auto",
  display: "flex",
  width: {
    xs: "min(100%, 300px)",
    sm: "calc((100% - 14px) / 2)",
    lg: "calc((100% - 28px) / 3)",
  },
  minWidth: { xs: 270, sm: 280 },
  maxWidth: { sm: "calc((100% - 14px) / 2)", lg: "calc((100% - 28px) / 3)" },
  scrollSnapAlign: "start",
  "& > *": { flex: 1, width: "100%" },
};

export const formInsightAdherenceStripSx = {
  ...panelTableCardSx,
  overflow: "hidden",
};

export const formInsightAdherenceHeaderTitleSx = {
  ...panelFormSectionTitleSx,
  mb: 0.25,
  fontSize: "1.05rem",
};

export const formInsightAdherenceHeaderHintSx = {
  fontSize: "0.8125rem",
  color: PANEL.text.muted,
  lineHeight: 1.45,
  maxWidth: 640,
};

export const formInsightAdherenceCellSx = (hot = false) => ({
  px: { xs: 1.35, md: 1.6 },
  py: { xs: 1.25, md: 1.45 },
  borderRadius: PANEL.radius.cardSm,
  bgcolor: hot ? PANEL.danger.soft : PANEL.fill.muted,
  border: `1px solid ${hot ? PANEL.danger.border : PANEL.border}`,
  minWidth: 0,
});

export const formInsightAdherenceCellLabelSx = (hot = false) => ({
  fontSize: "0.62rem",
  fontWeight: 600,
  color: PANEL.text.muted,
  letterSpacing: "0.06em",
  textTransform: "none",
  mb: 0.7,
  display: "flex",
  alignItems: "center",
  gap: 0.45,
  "& .MuiSvgIcon-root": {
    fontSize: 15,
    color: hot ? PANEL.danger.text : PANEL.text.label,
  },
});

export const formInsightAdherenceCellValueSx = (accent, emphasize = false) => ({
  fontWeight: 700,
  fontSize: emphasize ? "1.55rem" : "1.28rem",
  color: accent || PANEL.text.primary,
  lineHeight: 1.1,
  letterSpacing: "-0.03em",
  fontVariantNumeric: "tabular-nums",
});
